import CreateFacility from './CreateFacility'

export default CreateFacility
